export enum ShareToCustomerDialogMode {
    SAVING = 'Saving',
    ERROR = 'Error',
    SUCCESS = 'Success'
}
